import { render, staticRenderFns } from "./blockG.vue?vue&type=template&id=46a5ad82&scoped=true"
import script from "./blockG.vue?vue&type=script&lang=js"
export * from "./blockG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5ad82",
  null
  
)

export default component.exports